import React from 'react';
import PropTypes from 'prop-types';
import {
  space,
  display,
  color,
  MarginProps,
  PaddingProps,
  Config,
} from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import { breakpointsObject as bp } from '@firsttable/web-theme';

type BreadcrumbProps = MarginProps &
  PaddingProps & {
    color?: string;
    showShadowOverlay?: boolean;
  };

const StyledBreadcrumbs = styled.ul<BreadcrumbProps>`
  ${display};
  ${color};
  ${space};
  list-style: none;
  overflow-x: scroll;
  white-space: nowrap;
  position: relative;

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  /* Add a shadow on the right side */
  ${({ showShadowOverlay }) =>
    showShadowOverlay &&
    `
    ::after {
      content: '\\00a0\\00a0\\00a0\\00a0\\00a0\\00a0';
      position: sticky;
      right: -1px;
      top: 0;
      bottom: 0;
      width: 50px;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
      );
    }
  `}

  li {
    display: inline-block;
    margin-right: 30px;
    position: relative;

    &:last-child::after {
      display: none;
    }
  }

  li::after {
    content: ' ';
    position: absolute;
    width: 1px;
    margin: 4px 0 0 15px;
    transform: rotate(20deg) translate3d(0, 0, 0);
    height: 20px;
    background: ${themeGet('colors.grayscale.400')};

    @media screen and (min-width: ${bp.s}) {
      margin-top: -2px;
      height: 29px;
    }
  }
`;

const Breadcrumbs = ({
  mt = 0,
  mr = 0,
  ml = 0,
  mb = 0,
  pt = 0,
  pr = 0,
  pl = 0,
  pb = 's',
  color: crumbColor = 'grayscale.600',
  showShadowOverlay = true,
  ...props
}: BreadcrumbProps & React.HTMLAttributes<HTMLUListElement>) => (
  <StyledBreadcrumbs
    mt={mt}
    mr={mr}
    ml={ml}
    mb={mb}
    pt={pt}
    pr={pr}
    pl={pl}
    pb={pb}
    color={crumbColor}
    showShadowOverlay={showShadowOverlay}
    {...props}
  />
);

Breadcrumbs.propTypes = {
  p: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  mb: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  color: PropTypes.string,
  showShadowOverlay: PropTypes.bool,
};

export default Breadcrumbs;
